<template>
    <div class="flex h-full w-full">
        <div class="ml-from-side-bar w-full h-full">
            <router-view />
        </div>
    </div>
</template>
